import React from 'react';
import { ShieldAlertIcon } from 'lucide-react';
export function SafetyBanner() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2959">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2960">
        <div className="flex items-start gap-4 p-5 rounded-xl border-2" style={{
        backgroundColor: '#fffbeb',
        borderColor: '#c8a84b'
      }} data-id="element-2961">
          <ShieldAlertIcon size={28} className="flex-shrink-0 mt-0.5" style={{
          color: '#c8a84b'
        }} data-id="element-2962" />
          <div data-id="element-2963">
            <p className="text-lg font-bold mb-1" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2964">
              All members and guests must read and follow these rules.
            </p>
            <p className="text-sm text-gray-700" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2965">
              Violation of range rules may result in loss of membership
              privileges. Safety is everyone's responsibility.
            </p>
          </div>
        </div>
      </div>
    </div>;
}